import { createContext, useContext } from "react";
import { NotificationBadgeResponse } from "services/Notification/notificationInterface";

/**
 * Shares the signed-in user's notification badge summary (already fetched once in
 * the Sidebar via useNotificationBadge) with pages rendered inside the Outlet —
 * e.g. the Profile page, which uses it to show dots on its "Profile"/"Documents"
 * sub-tabs. Reading from context avoids a duplicate badge request.
 */
export const NotificationBadgeContext =
  createContext<NotificationBadgeResponse | null>(null);

export const useNotificationBadgeData = (): NotificationBadgeResponse | null =>
  useContext(NotificationBadgeContext);
